import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  input,
  Output,
  TemplateRef
} from '@angular/core';
import { ICampaignsCount } from '@libs/apis';
import { FadeInAnimator } from '@libs/common-animations';
import { TaxonomyDimension } from '../../models/ICampaignFilterContext';
import { TaxonomyFeature } from '../../models/TaxonomyFeature';
import { TaxonomyTab } from '../../models/TaxonomyTab';
import { CampaignAccordionService } from '../../services/campaign-accordion.service';
import { CampaignTableService } from '../../services/campaign-table.service';
import { TaxonomyUiConstants } from '../../taxonomy-ui/taxonomy-ui.constants';

@Component({
  selector: 'lib-taxonomy-campaign-accordion',
  templateUrl: './campaign-accordion.component.html',
  styleUrl: './campaign-accordion.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [FadeInAnimator.fade(TaxonomyUiConstants.defaultDurationInMillis)]
})
export class CampaignAccordionComponent {
  activeTaxonomyTab = input(TaxonomyTab.unmapped);
  accordions = input<ICampaignsCount[]>([]);
  groupByDimension = input<TaxonomyDimension>(
    TaxonomyDimension.compositeDataSourceName
  );

  geoTestStatusByDimension = input<Record<string, boolean>>({});
  loading = input(false);
  requestInProgress = input(false);
  activeAccordionIndex = input<number | null>(null);
  showUpdateMappingOverlay = input(false);
  clientId = input(0);
  brandId = input(0);
  activeAccordionDimensionValue = input('');
  viewFor = input(TaxonomyFeature.GA);
  tableTemplate = input<TemplateRef<unknown> | null>(null);
  dimensionUpdateTemplate = input<TemplateRef<unknown> | null>(null);
  @Output() activeIndexChange = new EventEmitter<number | null>();

  readonly campaignAccordionService = inject(CampaignAccordionService);
  readonly campaignTableService = inject(CampaignTableService);

  handleActiveIndexChange(event: number | null): void {
    this.campaignAccordionService.activeIndexChange(event);
    this.activeIndexChange.emit(event);
  }
}
